import { Reveal } from "@/components/Reveal";
import { GoldButton, Eyebrow } from "@/components/Section";
import { Orbit } from "@/components/Decor";
import { IMAGES } from "@/data/content";

export const CtaBanner = ({
  eyebrow = "Επόμενο Βήμα",
  title = "Ας μιλήσουμε για την επιχείρησή σας.",
  subtitle = "Μια πρώτη συζήτηση αρκεί για να δούμε πού υπάρχει πραγματικό περιθώριο βελτίωσης και ανάπτυξης.",
  buttonLabel = "Ξεκινήστε τη συζήτηση",
  to = "/contact",
}) => (
  <section data-testid="cta-banner" className="relative py-20 lg:py-28 bg-[#F2EEE7]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[36px] mesh-navy text-white shadow-[0_60px_120px_-60px_rgba(14,27,49,0.7)]">
          <div className="perspective-grid light" />
          <img src={IMAGES.hero} alt="" className="pointer-events-none absolute right-0 top-0 h-full w-1/2 object-cover opacity-20 [mask-image:linear-gradient(to_left,black,transparent)]" loading="lazy" />
          <Orbit className="absolute -right-24 -top-24 w-[420px] h-[420px] opacity-60 hidden lg:block" color="#C5A059" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center px-8 py-14 lg:px-16 lg:py-20">
            <div className="lg:col-span-8">
              <Eyebrow tone="#E39C82">{eyebrow}</Eyebrow>
              <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.08]">{title}</h2>
              <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/75 max-w-2xl">{subtitle}</p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <GoldButton to={to} testId="cta-banner-button" variant="copper">{buttonLabel}</GoldButton>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
